import { isRemote } from '../env';
import { LocalSettingsRepository } from './localRepository';
import { RemoteSettingsRepository } from './remoteRepository';
import { ISettingsRepository } from './ISettingsRepository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: ISettingsRepository | null = null;

export function getSettingsRepository(getToken?: () => Promise<string | null>): ISettingsRepository {
  if (!instance) {
    instance = isRemote ? new RemoteSettingsRepository(getToken ?? getAuthToken) : new LocalSettingsRepository();
  }
  return instance;
}
